import { Component, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';
import { MessageModule } from 'primeng/message';

interface ErrorData {
  title: string;
  source: string;
  icon: string;
  severity: 'info' | 'success' | 'warn' | 'danger';
  message?: string;
  code?: string;
}

@Component({
  selector: 'app-error-page',
  templateUrl: './error-page.component.html',
  styleUrls: ['./error-page.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    ButtonModule,
    CardModule,
    MessageModule,
  ],
})
export class ErrorPageComponent implements OnInit {
  errorData: ErrorData = {
    source: 'system',
    title: 'Une erreur est survenue',
    icon: 'pi pi-exclamation-triangle',
    severity: 'danger',
    message:
      'Veuillez réessayer plus tard ou contacter le support si le problème persiste.',
  };

  constructor() {}

  ngOnInit() {
    const state = history.state as ErrorData;

    console.log('Error state:', state);

    if (state && state.source) {
      this.errorData = {
        ...this.errorData,
        ...state,
      };

      switch (state.source) {
        case 'bff':
          this.errorData.title = 'Erreur de communication avec le serveur';
          this.errorData.icon = 'pi pi-server';
          break;
        case 'auth':
          this.errorData.title = "Erreur d'authentification";
          this.errorData.icon = 'pi pi-lock';
          break;
        case 'network':
          this.errorData.title = 'Erreur de réseau';
          this.errorData.icon = 'pi pi-wifi';
          break;
        default:
          this.errorData.title = 'Erreur système';
      }
    }
    if (state.code) {
      this.errorData.code = state.code;
    }
    if (state.severity) {
      this.errorData.severity = state.severity;
    }
    if (state.message) {
      this.errorData.message = state.message;
    }
  }

  goHome() {
    window.location.href = '/';
  }
}
